import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./Header.module.scss";
import HeaderLogo from "../../../../assets/HeaderLogo.svg";
import BetShuffleIcon from "../../../../assets/icons/shuffle.svg";
import TourSkipped from "../../../../components/TourSkipped";
import { SET_ACTIVE_VIEW } from "../../../../constants/actions";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import ToolTip from "../../../../components/OnboardingPopup/components/ToolTip";
import {
  BET_SHUFFLE,
  BET_SHUFFLE_TYPE,
  OPEN,
} from "../../../../constants/analytics";

export default function Header({ showOnboarding, closeOnboarding }) {
  const dispatch = useDispatch();
  const { onboardingStep } = useSelector((state) => state.filter);

  const betShuffleButtonClass = clsx(styles.betShuffleButton, {
    [styles.betShuffleButtonHighlighted]: onboardingStep === 7,
  });

  const openBetShuffle = () => {
    dispatch({ type: SET_ACTIVE_VIEW, payload: "betShuffle" });

    sendAnalyticsEvent({
      event: BET_SHUFFLE,
      type: BET_SHUFFLE_TYPE,
      action: OPEN,
    });
  };
  return (
    <header className={styles.header} role="banner">
      <picture>
        <img
          className={styles.headerImage}
          src={HeaderLogo}
          alt="Paddy Power Mix 'N Match Bet Builder Logo"
        />
        <div className={styles.betShuffleContainer}>
          <button
            type="button"
            aria-label="bet shuffle"
            onClick={openBetShuffle}
            className={betShuffleButtonClass}
          >
            Bet Shuffle <img src={BetShuffleIcon} alt="Bet Shuffle" />
          </button>
          {onboardingStep === 7 ? (
            <ToolTip closeOnboarding={closeOnboarding} />
          ) : null}
        </div>
        <TourSkipped showOnboarding={showOnboarding} />
      </picture>
    </header>
  );
}
